import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@knockrentals/knock-react';
import GroupUserDeleteConfirm from './GroupUserDeleteConfirm';

const GroupUserDeleteModal = ({
  eligibleTransferRecipients,
  onCancel,
  onDelete,
  user,
}) => {
  const [transferRecipientUserId, setTransferRecipientUserId] = useState(
    eligibleTransferRecipients[0].user_id
  );
  const [transferRecipient, setTransferRecipient] = useState({});

  const handleConfirmOnClick = () => {
    const user = eligibleTransferRecipients.find(
      (user) => user.user_id === transferRecipientUserId
    );
    setTransferRecipient(user);
  };

  const handleTransferRecipientOnChange = (event) => {
    setTransferRecipientUserId(Number(event.target.value));
  };

  const deleteUser = () => {
    onDelete(user.user_id, transferRecipient.user_id);
  };

  const username = user.cognito_username || user.username;
  const transferRecipientUsername =
    transferRecipient.cognito_username || transferRecipient.username;

  if (transferRecipient.user_id) {
    return (
      <GroupUserDeleteConfirm
        handleDeleteOnClick={deleteUser}
        onBack={() => {
          setTransferRecipient({});
        }}
        onCancel={onCancel}
        transferRecipientUsername={transferRecipientUsername}
        username={username}
      />
    );
  }

  return (
    <div className="group-user-delete">
      <Modal>
        <ModalHeader>
          <h3>Delete {username}</h3>
        </ModalHeader>

        <ModalContent>
          <div>
            <div>Select a user as the recipient for the data transfer.</div>

            <div className="transfer-recipient">
              <label>
                Data transfer recipient:
                <select
                  value={transferRecipientUserId}
                  onChange={handleTransferRecipientOnChange}
                >
                  {eligibleTransferRecipients.map((user) => (
                    <option key={user.user_id} value={user.user_id}>
                      {user.first_name} {user.last_name}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </div>
        </ModalContent>

        <ModalFooter>
          <button className="knock-react-button" onClick={onCancel}>
            Cancel
          </button>

          <button
            className="knock-react-button danger"
            onClick={handleConfirmOnClick}
          >
            Confirm
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

GroupUserDeleteModal.propTypes = {
  eligibleTransferRecipients: PropTypes.arrayOf(
    PropTypes.shape({
      cognito_username: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      username: PropTypes.string,
      user_id: PropTypes.number,
    })
  ),
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  user: PropTypes.shape({
    cognito_username: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    username: PropTypes.string,
    user_id: PropTypes.number,
  }),
};

export default GroupUserDeleteModal;
